import React from 'react';
import { CardTitle, CardSubhead } from '@spark/ui-components/components/Card';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import BottomStatusFilter from '@spark/ui-components/components/BottomStatusFilter';
import styled from 'styled-components';

const ProgramacaoHeader = ({
  totalRegistros = 0,
  onAdicionar,
  statusValue,
  onStatusChange,
  statusCounts,
}) => {
  const statusOptions = [
    {
      value: 'coleta_no_porto',
      label: 'COLETA PORTO',
      icon: 'truck',
      count: statusCounts?.coleta_no_porto ?? 0,
    },
    {
      value: 'baixado_aguardando_cheio_barra_velha',
      label: 'BX CHEIO BV',
      icon: 'inbox-arrow-down',
      count: statusCounts?.baixado_aguardando_cheio_barra_velha ?? 0,
    },
    {
      value: 'baixado_aguardando_cheio_itapoa',
      label: 'BX CHEIO ITA',
      icon: 'inbox-arrow-down',
      count: statusCounts?.baixado_aguardando_cheio_itapoa ?? 0,
    },
    {
      value: 'baixado_aguardando_vazio_barra_velha',
      label: 'BX VAZIO BV',
      icon: 'inbox-arrow-down',
      count: statusCounts?.baixado_aguardando_vazio_barra_velha ?? 0,
    },
    {
      value: 'baixado_aguardando_vazio_itapoa',
      label: 'BX VAZIO ITA',
      icon: 'inbox-arrow-down',
      count: statusCounts?.baixado_aguardando_vazio_itapoa ?? 0,
    },
    {
      value: 'finalizado',
      label: 'FINALIZADO',
      icon: 'check',
      count: statusCounts?.finalizado ?? 0,
    },
  ];

  return (
    <HeaderWrap>
      <div>
        <CardTitle>Programação</CardTitle>
        <CardSubhead>
          Total de registros: {totalRegistros}
        </CardSubhead>

        {onStatusChange && (
          <StatusFilterRow>
            <BottomStatusFilter
              options={statusOptions}
              value={statusValue}
              onChange={onStatusChange}
            />
          </StatusFilterRow>
        )}
      </div>

      {onAdicionar && (
        <ButtonContainer>
          <ButtonWithLoading variant="primary" onClick={onAdicionar}>
            Adicionar
          </ButtonWithLoading>
        </ButtonContainer>
      )}
    </HeaderWrap>
  );
};

export default ProgramacaoHeader;

const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;

  @media (max-width: 576px) {
    align-items: flex-start;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  @media (max-width: 576px) {
    align-items: flex-start;
    margin-top: 0;
  }
`;

const StatusFilterRow = styled.div`
  margin-top: 12px;
`;
